// extracted by mini-css-extract-plugin
module.exports = {"skuButton":"addskunotice_skuButton___9gsG","arrow":"addskunotice_arrow__EKu9J","fadein":"addskunotice_fadein__ZqPGW","loading":"addskunotice_loading__U14Xy"};